import * as CATEGORIES from './categories.constants';
import { Category } from '../../models/';

/** LOAD */
export function loadCategories() {
    return { type: CATEGORIES.CATEGORIES_LOAD };
}

export function loadCategoriesSuccess(data: Category[]) {
    return { type: CATEGORIES.CATEGORIES_LOAD_SUCCESS, payload: data };
}

export function loadCategoriesError(error: any) {
    return { type: CATEGORIES.CATEGORIES_LOAD_ERROR, payload: error };
}


/** ADD */
export function addCategories(targetCategories: Category[]) {
    return { type: CATEGORIES.CATEGORIES_ADD, payload: targetCategories };
}

export function addCategoriesSuccess(targetCategories: Category[]) {
    return { type: CATEGORIES.CATEGORIES_ADD_SUCCESS, payload: targetCategories };
}

export function addCategoriesError(error: any) {
    return { type: CATEGORIES.CATEGORIES_ADD_ERROR, payload: error };
}


/** UPDATE */
export function updateCategories(targetCategories: Category[]) {
    return { type: CATEGORIES.CATEGORIES_UPDATE, payload: targetCategories };
}

export function updateCategoriesSuccess(targetCategories: Category[]) {
    return { type: CATEGORIES.CATEGORIES_UPDATE_SUCCESS, payload: targetCategories };
}

export function updateCategoriesError(error: any) {
    return { type: CATEGORIES.CATEGORIES_UPDATE_ERROR, payload: error };
}


/** DELETE */
export function deleteCategories(guids: string[]) {
    return { type: CATEGORIES.CATEGORIES_DELETE, payload: guids };
}

export function deleteCategoriesSuccess(categories: Category[]) {
    return { type: CATEGORIES.CATEGORIES_DELETE_SUCCESS, payload: categories };
}

export function deleteCategoriesError(error: any) {
    return { type: CATEGORIES.CATEGORIES_DELETE_ERROR, payload: error };
}